import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-ativity-filter',
  templateUrl: './ativity-filter.component.html',
  styleUrls: ['./ativity-filter.component.scss']
})
export class AtivityFilterComponent implements OnInit {
  @Input() filters;
  @Input() isSite;
  @Input() loading;
  @Input() facets;
  @Output() update = new EventEmitter();
  public filterCreateDate;
  public fileTypeForms: FormGroup;
  constructor() {}

  ngOnInit() {
  }
}
